"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _EmptyResult = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/EmptyResult"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var eventHandlerUtils = _interopRequireWildcard(require("../../utils/eventHandlers"));
var refUtils = _interopRequireWildcard(require("../../utils/refs"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ArrowUpIcon = function ArrowUpIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.707 15.29a1 1 0 0 1-1.414 0l-4.288-4.288-4.299 4.288a1 1 0 1 1-1.412-1.415l4.3-4.29c.78-.78 2.043-.78 2.823 0l4.29 4.29a1 1 0 0 1 0 1.415z"
  }));
};
ArrowUpIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "table": "table_39ZpAa",
  "sort-icon": "sort-icon_3cO8LO",
  "sortIcon": "sort-icon_3cO8LO",
  "hidden": "hidden_3GHytd",
  "sortable": "sortable_VK-3FI",
  "loading-sort": "loading-sort_AkE92F",
  "loadingSort": "loading-sort_AkE92F",
  "selected": "selected_28FZeD",
  "disabled": "disabled_YCZtXY",
  "toggler": "toggler_2hwm8H",
  "toggler-button": "toggler-button_2kIPQQ",
  "togglerButton": "toggler-button_2kIPQQ"
}; 
require('./Table.css');
var getInverseSort = function getInverseSort(sort) {
  return sort === 'ascending' ? 'descending' : 'ascending';
};
var Table = function Table(props) {
  var _props$renderRows;
  var ariaLive = props.ariaLive,
    caption = props.caption,
    className = props.className,
    testId = props.testId,
    headers = props.headers;
  var _React$useState = _react.default.useState(true),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    showMore = _React$useState2[0],
    setShowMore = _React$useState2[1];
  var tryFn = (0, _exchangeReactHooks.useTryFn)();
  var _React$useState3 = _react.default.useState(null),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    sortingHeader = _React$useState4[0],
    setSortingHeader = _React$useState4[1];
  var toggleShowMore = function toggleShowMore() {
    if ('rows' in props && showMore && props.firstAfterMinimumRef) {
      refUtils.focus(props.firstAfterMinimumRef);
    }
    setShowMore(!showMore);
  };
  var handleSorting = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator().m(function _callee2(header) {
      var sort;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            sort = getInverseSort((sortingHeader === null || sortingHeader === void 0 ? void 0 : sortingHeader.header) === header ? sortingHeader.sort : null);
            if (!(header.onSorting && 'rows' in props)) {
              _context2.n = 2;
              break;
            }
            setSortingHeader({
              header: header,
              sort: sort,
              isLoading: true
            });
            _context2.n = 1;
            return tryFn(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator().m(function _callee() {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return header.onSorting(props.rows, sort);
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            })));
          case 1:
            setSortingHeader({
              header: header,
              sort: sort,
              isLoading: false
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function handleSorting(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var defaultRenderRows = function defaultRenderRows() {
    if (!('rows' in props)) {
      return null;
    }
    var minRows = props.minRows,
      isRowDisabled = props.isRowDisabled,
      isRowSelected = props.isRowSelected,
      rowClassName = props.rowClassName,
      rows = props.rows;
    var minimumRows = Number.isNaN(minRows) ? rows.length : minRows;
    var isCollapsible = rows.length > minimumRows;
    var displayableRows = isCollapsible && showMore ? rows.slice(0, minimumRows) : rows;
    return displayableRows.map(function (row, rowIndex) {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: "row-".concat(testId ? "".concat(testId, "-") : '').concat(rowIndex),
        className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, styles.selected, isRowSelected(row)), styles.disabled, isRowDisabled(row)), typeof rowClassName === 'string' ? rowClassName : rowClassName(row)),
        "data-test-id": testId && "row-".concat(rowIndex, "-").concat(testId)
      }, headers.map(function (header, headerIndex) {
        return /*#__PURE__*/_react.default.createElement("td", {
          key: "row-".concat(testId ? "".concat(testId, "-") : '', "-").concat(rowIndex, "-").concat(headerIndex),
          className: header.className
        }, 'render' in header ? header.render(row, rowIndex) : row[header.key]);
      }));
    });
  };
  if ('rows' in props && props.rows.length === 0 && props.emptyResultMessage) {
    return /*#__PURE__*/_react.default.createElement(_EmptyResult.default, {
      message: props.emptyResultMessage
    });
  }
  var isCollapsible = false;
  if ('rows' in props) {
    var minimumRows = Number.isNaN(props.minRows) ? props.rows.length : props.minRows;
    isCollapsible = props.rows.length > minimumRows;
  }
  var rows = 'children' in props ? props.children : ((_props$renderRows = props.renderRows) !== null && _props$renderRows !== void 0 ? _props$renderRows : defaultRenderRows)(props.rows);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames.default)(styles.table, className),
    "data-test-id": testId && "table-".concat(testId),
    "aria-live": ariaLive
  }, caption ? /*#__PURE__*/_react.default.createElement("caption", {
    className: "visually-hidden"
  }, caption) : null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    "data-test-id": testId && "table-header-".concat(testId)
  }, headers.map(function (header, headerIndex) {
    var headerState = (sortingHeader === null || sortingHeader === void 0 ? void 0 : sortingHeader.header) === header ? sortingHeader : null;
    var sortingFn = headerState !== null && headerState !== void 0 && headerState.isLoading ? null : function () {
      return handleSorting(header);
    };
    return /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      key: "header-".concat(headerIndex),
      "data-test-id": testId && "row-header-".concat(headerIndex, "-").concat(testId),
      className: header.className
    }, header.onSorting ? /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": "header-sorting-".concat(headerIndex),
      role: "button",
      className: (0, _classnames.default)(styles.sortable, (0, _defineProperty2.default)({}, styles.loadingSort, headerState === null || headerState === void 0 ? void 0 : headerState.isLoading)),
      "aria-label": "Sort ".concat(getInverseSort(headerState === null || headerState === void 0 ? void 0 : headerState.sort)),
      tabIndex: 0,
      onClick: sortingFn,
      onKeyDown: eventHandlerUtils.onEnterKey(sortingFn)
    }, header.hidden ? /*#__PURE__*/_react.default.createElement("span", {
      className: "visually-hidden"
    }, header.label) : header.label, header.onSorting ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.sortIcon, (0, _defineProperty2.default)({}, styles.hidden, !headerState))
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      isDecorative: true,
      size: "xs"
    }, !sortingHeader || (sortingHeader === null || sortingHeader === void 0 ? void 0 : sortingHeader.sort) === 'ascending' ? /*#__PURE__*/_react.default.createElement(ArrowDownIcon, null) : /*#__PURE__*/_react.default.createElement(ArrowUpIcon, null))) : null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header.hidden ? _react.default.createElement("span", {
      className: "visually-hidden"
    }, header.label) : header.label, header.onSorting ? _react.default.createElement("div", {
      className: (0, _classnames.default)(styles.sortIcon, (0, _defineProperty2.default)({}, styles.hidden, !headerState))
    }, _react.default.createElement(_Icon.default, {
      isDecorative: true,
      size: "xs"
    }, !sortingHeader || (sortingHeader === null || sortingHeader === void 0 ? void 0 : sortingHeader.sort) === 'ascending' ? _react.default.createElement(ArrowDownIcon, null) : _react.default.createElement(ArrowUpIcon, null))) : null));
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, rows)), isCollapsible ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "collapsible-table-toggler",
    className: styles.toggler
  }, /*#__PURE__*/_react.default.createElement("span", {
    tabIndex: 0,
    role: "button",
    "data-test-id": "collapsible-table-toggler-button",
    className: styles.togglerButton,
    onClick: toggleShowMore,
    onKeyDown: eventHandlerUtils.onEnterKey(toggleShowMore)
  }, showMore ? 'Show more' : 'Show less')) : null);
};
Table.defaultProps = {
  rowClassName: function rowClassName() {},
  isRowSelected: function isRowSelected() {
    return false;
  },
  isRowDisabled: function isRowDisabled() {
    return false;
  },
  caption: ''
};
Table.defaultSorting = function sortingWrapper(key) {
  return function sorting(rows, sort) {
    var getSource = typeof key === 'function' ? function (value) {
      return key(value);
    } : function (value) {
      return value[key];
    };
    return (0, _toConsumableArray2.default)(rows).sort(function (a, b) {
      var aSource = getSource(a);
      var bSource = getSource(b);
      var comparison = sort === 'ascending' ? aSource > bSource : aSource < bSource;
      return comparison ? 1 : -1;
    });
  };
};
var _default = exports.default = Table;
//# sourceMappingURL=Table.js.map